import $ from 'jquery';
import 'slick-carousel';
import settings from './Settings.Sponsors';

const breakpoint = 768;

export default class Sponsors {
  constructor(element) {
    this.$element = $(element);
    this.$instance = this.getInstance();
    this.change = this.change.bind(this);
    this.active = false;
    this.change();
    this.listen();
  }

  update() {
    this.ticking = false;
    if (window.innerWidth >= breakpoint) {
      this.enable();
    } else {
      this.disable();
    }
  }

  enable() {
    if (!this.$instance.get(0).slick || !this.active) {
      this.$instance.slick(settings);
      this.active = true;
    }
  }

  disable() {
    if (this.active) {
      this.$instance.slick('unslick');
      this.active = false;
    }
  }

  getInstance() {
    return this.$element.find('.view-content');
  }

  listen() {
    $(window).on('resize orientationchange', this.change);
  }

  change() {
    this.requestTick();
  }

  requestTick() {
    if (!this.ticking) {
      requestAnimationFrame(this.update.bind(this));
      this.ticking = true;
    }
  }
}



// WEBPACK FOOTER //
// ./Sponsors.js